import React, { useState } from 'react';
import { Container, Box, Typography, Link } from '@mui/material';
import { postPasswordResetMail } from '../../api/authentication';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/Input';
import Grid from '@mui/material/Grid2';

const PasswordResetByUser = () => {
  const [email, setEmail] = useState('');
  const [emailText, setEmailText] = useState('');
  const navigate = useNavigate();

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      const data = await postPasswordResetMail(email);

      if (data.email === 'Password reset email sent.') {
        navigate('/login');
      } else if (data.email === 'Invalid') {
        setEmailText('Please check your email address');
        setEmail('');
      } else if (data.email !== '' || data.status === 0) {
        setEmailText(data.email);
        setEmail('');
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          p: 4,
          mt: 2,
          mb: 6,
        }}
      ></Box>

      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2} className="container-grid">
          <Grid size={8} className="wrapper-container-grid">
            <div className="header-login">Password Reset</div>
            <Box sx={{ color: 'error.main', marginLeft: '50px' }}>{emailText}</Box>
            <form onSubmit={handleSubmit} id="login-contents" className="password-reset">
              <Typography>
                Enter your registered email address then check your email inbox including spam folders.
              </Typography>
              <Input name="username" type="text" label="Email Address" value={email} onChange={handleEmailChange} />

              <button style={{ height: '3rem', marginTop: '0.1rem' }} className="login-button" onClick={handleSubmit}>
                Continue to reset
              </button>
              <div style={{ margin: '1rem 0' }}>
                <Link onClick={handleBack} variant="body2" className="back-button">
                  Back
                </Link>
              </div>
            </form>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          p: 4,
          mt: 2,
          mb: 6,
        }}
      ></Box>
    </Container>
  );
};

export default PasswordResetByUser;
